/* Ravi R : 05-08-2025 : BREEZE-9399 - Auto lock feature in Breeze - AutoLockModal : Start */

import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BzButton, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzTab, BzTabs, BzTabsContainer, BzTabsContent } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { handleModal } from "../../redux/actions/modals";
import { API_CODES, API_ERRORS, API_SOURCE, COVER, LOCAL_STORAGE_KEYS, LOGIN_CONSTANTS, MPIN_INPUT_CLASSES } from "../../utils/global_variables";
import { encryptTDES, getActiveUser, getDecryptLocalStorage, getStorageWithMultiTabCheck, setEncryptLocalStorage } from "../../utils/global_functions";
import config from '../../config.json'
import { loginSession } from "../../apis";
import FocusLock from "react-focus-lock";
import { userLogout } from "../../redux/actions/auth";

const AutoLockModal = () => {
    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const [mpin, setMpin] = useState(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
    const [password,setPassword]=useState('');
    const [errorObj, setErrorObj] = useState({ error: MPIN_INPUT_CLASSES.NO_CLASS, message: '', code: '' }); // 0 - no class, 1 - Success, 2 - Error
    const [showPassword, setShowPassword] = useState(false);
    const inputRef = useRef(null);
    const passwordRef = useRef(null);
    const [bSubLoginButton, setBSubLoginButton] = useState(true);
    const isMpinEnabled = getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.MPIN_ENABLE);
    const { bMpinEnabled } = useSelector(state => state.auth);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();
    const [tabKey, setTabKey] = useState(isMpinEnabled ? 'mpin' : 'pswd');

    useEffect(()=>{
        inputRef.current?.focus();
    },[])

    const closeAutoLockModal=()=>{
        dispatch(handleModal([{ 'AUTO_LOCK_MODAL': false }]));
        const autoLockSessionObj = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS));
        const activeUser = getActiveUser(objLoginSession);
        const obj = { ...autoLockSessionObj, [activeUser]: { ...autoLockSessionObj?.[activeUser], isModalOpen: false } };
        setEncryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS, JSON.stringify(obj));
    }
    const userLoginOnAutoLock = useCallback(async (userId = '', password = '', loginType = '', secondAuthType = '', secondAuthValue = '') => {
        try{
            if(isLoading){
                return
            }
            setIsLoading(true)
            const payload = {
                "user_id": userId,
                "login_type": loginType,
                "password": password,
                "second_auth": secondAuthValue,
                "api_key": config.Wave.ApiKey,
                "source": API_SOURCE.BREEZE,
                "version": API_SOURCE.VERSION,
                "buildVersion": config.buildVersion
            };
            if (loginType === 'MPIN_TDES') {
                payload[`second_auth_type`] = secondAuthType;
            } else if (loginType === 'PASSWORD_TDES' || loginType === 'TOKEN') {
                payload[`second_auth_type`] = secondAuthType;
            } else { }

            const objResp = await loginSession(payload);

            if (objResp?.data?.code === API_CODES.ECODE_SUCCESS) {
                closeAutoLockModal()
            }
            setIsLoading(false)
        }
        catch(error){
            setIsLoading(false)
            setErrorObj({ ...errorObj, error: MPIN_INPUT_CLASSES.ERROR, message: error.response.data.message, code: error.response.data.code });
        }
        
    }, [dispatch, errorObj, isLoading])

    const handleUserMpin = useCallback(() => {
        const user = objLoginSession?.data?.alias_id ? objLoginSession.data.alias_id : objLoginSession?.data?.user_id
        if (Boolean(isMpinEnabled && bMpinEnabled)) {
            if (mpin.join("") && mpin.join("").length === LOGIN_CONSTANTS.MPIN_LENGTH) {
                
                let enteredMpin = mpin.join('');
                setMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(''));
                userLoginOnAutoLock(user, encryptTDES(COVER.TDES, enteredMpin), 'MPIN_TDES', 'REGISTER', '')
            }
        }
    }, [objLoginSession.data.alias_id, objLoginSession.data?.user_id, isMpinEnabled, bMpinEnabled, mpin, userLoginOnAutoLock]);

     useEffect(() => {
        if (mpin.join("") && mpin.join("").length === LOGIN_CONSTANTS.MPIN_LENGTH) {
          handleUserMpin();
        }
      }, [handleUserMpin, mpin]);

    const handleTabChange = (value) => {
        setTabKey(value);
        setErrorObj({ ...errorObj, error: MPIN_INPUT_CLASSES.NO_CLASS, message: '', code: '' });
    };
    const handleMpinChange = useCallback((element, index) => {
        if (/^[a-zA-z\s\W]+$/.test(element.value)) {
            setMpin(mpin.map((d, idx) => ((idx === index ? '' : d))));
        }
        else {
            setMpin([...mpin.map((d, idx) => ((idx === index ? element.value : d)))]);
            if (element.value && element.nextSibling) {
                if (!element.value) {
                    element.nextSibling.focus();
                }
            } else { }
        }
    }, [mpin]);

    const handleMpinKeyUp = useCallback((e, index) => {
        let key = e.keyCode || e.charCode;
        if (/^[a-zA-z\s\W]+$/.test(e.target.value)) {
        }
        else {
            setMpin([...mpin.map((d, idx) => (idx === index ? e.target.value : d))]);
        }
        if (key === 8 && e.target.previousSibling) {
            e.target.previousSibling.focus();
        }
        else {
            if (/^[a-zA-z\s\W]+$/.test(e.target.value)) { }
            else {
                if (e.target.value && e.target.nextSibling) {
                    e.target.nextSibling.focus();
                } else { }
            }
        }
    }, [mpin]);

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        if (value.length >= LOGIN_CONSTANTS.LOGIN_PASSWORD_MIN_LENGTH) {
            setBSubLoginButton(false)
        }
        else {
            setBSubLoginButton(true)
        }
    };
    const handleTakeMeToLogin = () => {
        dispatch(userLogout()).then().catch().finally(()=>{
            localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
            window.location.replace('/');
            closeAutoLockModal()
        })

    };
 const handleVerify = useCallback(() => {
    userLoginOnAutoLock(objLoginSession?.data?.user_id, encryptTDES(COVER.TDES, password), 'PASSWORD_TDES', 'REGISTER', '')
  }, [objLoginSession?.data?.user_id, password, userLoginOnAutoLock]);
  
    return (
        <FocusLock className='focus-overflow' >
            <BzModal size='md' centered show={modals['AUTO_LOCK_MODAL']} onHide={()=> {}} onExiting={() => {}} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={12} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>{`Enter ${isMpinEnabled && bMpinEnabled ? 'M-Pin or' : ''} Password To Resume Trading`}</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Row className='g-0 mb-3'>
                        <div className='horizontal-scroll-wrap'>
                            <BzTabs className='nav nav-tabs'>
                                {isMpinEnabled && bMpinEnabled && <BzTab onClick={() => handleTabChange('mpin')} className='nav-link text-capitalize' tabindex={null} isActive={tabKey === 'mpin'} tabKey='mpin'>M-PIN</BzTab>}
                                <BzTab data-testid='pwd_tab_btn' onClick={()=>handleTabChange('pswd')} className='nav-link text-capitalize px-5' tabindex={null} isActive={tabKey === 'pswd'} tabKey='pswd'>Password</BzTab>
                            </BzTabs>
                        </div>
                    </Row>
                    <BzTabsContainer>
                        {isMpinEnabled && bMpinEnabled && <BzTabsContent showDefault isActive={tabKey === 'mpin'} tabKey='mpin'>
                            <div>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size2 color-text'>Enter M-Pin</div>
                                    </Col>
                                </Row>
                                <div className='mb-3'>
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='mpin-wrap'>
                                                {
                                                    mpin.map((data, index) => {
                                                        return (
                                                            <BzInputText
                                                                data-testid={"mpin-input"}
                                                                type="password"
                                                                name="mpin"
                                                                autoComplete='new-password'
                                                                maxLength="1"
                                                                className={`font-regular form-control ${errorObj.error === MPIN_INPUT_CLASSES.SUCCESS ? 'success' : (errorObj.error === MPIN_INPUT_CLASSES.ERROR ? 'error' : '')}`}
                                                                key={index}
                                                                value={data}
                                                                onChange={e => handleMpinChange(e.target, index)}
                                                                onKeyUp={e => handleMpinKeyUp(e, index)}
                                                                onFocus={e => e.target.select()}
                                                                ref={index === 0 ? inputRef : null}
                                                            />
                                                        );
                                                    })
                                                }
                                            </div>
                                            {errorObj.error === MPIN_INPUT_CLASSES.SUCCESS ? <div className='icon-20 icon-checktick icon-positive'></div> : ''}
                                            {errorObj.error === MPIN_INPUT_CLASSES.ERROR ? <div className='icon-20 icon-close-fill icon-negative'></div> : ''}
                                        </Col>
                                    </Row>
                                    {errorObj.error === MPIN_INPUT_CLASSES.ERROR &&
                                        <Row className='g-0 mt-2'>
                                            <Col className='d-flex justify-content-start'>
                                                <div className='error-msg text-wrap'>{errorObj.message}</div>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </div>
                        </BzTabsContent>}
                        <BzTabsContent tabKey='pswd' showDefault isActive={tabKey === 'pswd'} >
                            <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
                                <div>
                                    <Row className='g-0 mb-2'>
                                        <Col>
                                            <div className='font-medium font-size2 color-text'>Enter Password</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-2'>
                                        <Col>
                                            <div className={`input-group position-relative `}>
                                                <BzInputText data-testid='pwd_field_during_relogin' ref={passwordRef} name='user_password' value={password} type={`${showPassword ? 'text' : 'password'}`} placeholder='Password' maxLength={LOGIN_CONSTANTS.LOGIN_PASSWORD_MAX_LENGTH} onChange={handlePasswordChange} className={`font-regular font-size2 pe-5 ${errorObj?.error === MPIN_INPUT_CLASSES.ERROR ? 'error' : ''}`} />
                                                <div data-testid={"icon-eye"} onClick={() => { setShowPassword(curr => !curr); }} className={`icon-20 ${showPassword ? 'icon-eye' : 'icon-eyeslash'} icon-grey login-icon-position`}></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {(errorObj?.error === MPIN_INPUT_CLASSES.ERROR && errorObj?.code !== API_ERRORS.ECODE_PWD_EXPIRED) &&
                                        <Row className='g-0 mb-2'>
                                            <Col>
                                                <div className='error-msg'>{errorObj.message}</div>
                                            </Col>
                                        </Row>
                                    }
                                    <Row className='g-0 mb-3'>
                                        <Col>
                                            <BzButton data-testid='verify_btn_during_relogin' type='submit' className='btn btn-md btn-block btn-primary' onClick={handleVerify} disabled={bSubLoginButton}>Verify</BzButton>
                                        </Col>
                                    </Row>
                                </div>
                            </form>
                        </BzTabsContent>
                    </BzTabsContainer>
                </BzModalBody>
                <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-start'>
                        <Col className='d-flex align-items-center'>
                            <span className='font-regular font-size4 color-text line-height-1'>Facing any issues?</span> 
                            <a className='font-medium font-size3 focus ms-1 line-height-1 text-decoration-underline' onClick={handleTakeMeToLogin}>Take me to Login</a>
                        </Col>
                    </Row>
                </Container>
                </BzModalFooter>
            </BzModal>
         </FocusLock>
    )
}
export default memo(AutoLockModal)

/* Ravi R : 05-08-2025 : BREEZE-9399 - Auto lock feature in Breeze - AutoLockModal : End */